export default __webpack_public_path__ + "static/media/office365.8913ce39.svg";